import React from 'react';
import { motion } from 'framer-motion';
import { ListIcon, CheckIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function BenefitsTable() {
  const {
    t
  } = useLanguage();
  const benefits = t('benefits.items');
  return <section className="py-24 bg-brand-bg-light" data-id="element-48">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-50">
          <div className="flex items-center justify-center gap-4 mb-16" data-id="element-51">
            <ListIcon className="w-10 h-10 text-brand-green" data-id="element-52" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-53">
              {t('benefits.title')}
            </h2>
          </div>

          <div className="bg-brand-bg-dark rounded-2xl border border-brand-green/20 overflow-hidden shadow-2xl" data-id="element-54">
            {/* Desktop Table Header */}
            <div className="hidden md:grid grid-cols-2 bg-brand-green-dark/50 border-b border-brand-green/30 p-6" data-id="element-55">
              <h3 className="text-xl font-heading font-bold text-brand-gold uppercase tracking-wider" data-id="element-56">
                {t('benefits.header1')}
              </h3>
              <h3 className="text-xl font-heading font-bold text-white uppercase tracking-wider" data-id="element-57">
                {t('benefits.header2')}
              </h3>
            </div>

            {/* Table Body */}
            <div className="divide-y divide-gray-800" data-id="element-58">
              {Array.isArray(benefits) && benefits.map((item: any, index: number) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.05
            }} className="grid md:grid-cols-2 p-6 hover:bg-white/5 transition-colors group" data-id="element-59">
                    <div className="flex items-center gap-3 mb-2 md:mb-0" data-id="element-60">
                      <CheckIcon className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-61" />
                      <span className="text-lg font-medium text-gray-200 group-hover:text-brand-gold transition-colors" data-id="element-62">
                        {item.feature}
                      </span>
                    </div>
                    <div className="flex items-center text-lg text-gray-400 md:pl-6 md:border-l border-gray-800" data-id="element-63">
                      {item.benefit}
                    </div>
                  </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}